module.exports = __webpack_public_path__ + "img/profile.9885f631.svg";